// extracted by mini-css-extract-plugin
export default {"empty_cart_block":"EmptyCart_empty_cart_block__jv-Xq","text_empty_cart":"EmptyCart_text_empty_cart__gqMOo","text_add_items":"EmptyCart_text_add_items__ZfIOb"};